import { DocPurpose } from '../../interfaces/invoice.interface';

export const DOC_PURPOSE_AADE_CODE = {
  SALE: '1',
  BUY: '9',
};

export const getDocPurposesWithoutDocTypeValue = (data: DocPurpose[]) => {
  return data.filter((docPurpose) => !docPurpose.documentTypeAadeCode);
};

export const getDocPurposesWithDocType = (data: DocPurpose[]) => {
  return data.filter((docPurpose) => !!docPurpose.documentTypeAadeCode);
};
